export const STAT_REPORT = 'stat.getStatisticsReport';
export const TRANSLATIONS = 'translations.get';

export const GET_FRIENDS = 'users.getInvitableFriends';
export const GET_SETTINGS = 'settings.get';

export const GET_SNAKES = 'snake_2025.getSnakesCatalog';
export const GET_USER_STATE = 'snake_2025.getUserState';
export const OPEN_LOOTBOX = 'snake_2025.openLootbox';
export const SELECT_SNAKE = 'snake_2025.selectSnake';
export const EXCHANGE_SNAKE = 'snake_2025.exchangeSnake';
export const ROLL_REVOLVER = 'snake_2025.rollRevolver';

export const COMPLETE_QUEST = 'gamification.missionStateChanged';
export const LOG_OPERATION = 'log.externalGamingLog';
export const CLOSE_BANNER = 'banners.closeBanner';
export const GAME_ACT = 'game.act';

export const STORAGE_SET = 'storage.set';
export const STORAGE_GET = 'storage.get';
